import { mergeAttributes, Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";

import Component from "./FileChip";
export default Node.create({
  name: "fileChip",
  inline: true,
  group: "inline",

  atom: true,

  addAttributes() {
    return {
      type: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-type"),
        renderHTML: (attributes) => {
          if (!attributes.type) return {};
          return { "data-type": attributes.type };
        },
      },
      name: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-name"),
        renderHTML: (attributes) => {
          if (!attributes.name) return {};
          return { "data-name": attributes.name };
        },
      },
      src: {
        default: "",
        parseHTML: (element) => element.getAttribute("data-src"),
        renderHTML: (attributes) => {
          if (!attributes.src) return {};
          return { "data-src": attributes.src };
        },
      },
      isLoading: {
        default: false,
        parseHTML: (element) => element.getAttribute("data-loading"),
        renderHTML: (attributes) => {
          if (!attributes.isLoading) return {};
          return { "data-loading": attributes.isLoading };
        },
      },
      "data-placeholder-id": {
        default: "",
        parseHTML: (element) => element.getAttribute("data-placeholder-id"),
        renderHTML: (attributes) => {
          if (!attributes["data-placeholder-id"]) return {};
          return { "data-placeholder-id": attributes["data-placeholder-id"] };
        },
      },
      errorMessage: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-error-message"),
        renderHTML: (attributes) => {
          if (!attributes.errorMessage) return {};
          return { "data-error-message": attributes.errorMessage };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "span[data-type='file-chip']",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, { "data-type": "file-chip" }),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(Component);
  },
});
